import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
  formDataPostRequest,
  formDataPutRequest,
} from "../system/server-calls";
import responseHandler from "../system/server-response-handler";

const GetDashboardData = ({ startDate = null, endDate = null }) => {
  const url = `Dashboard/GetDashboardData?fromDate=${startDate ?? ""}&toDate=${
    endDate ?? ""
  }`;
  return getRequest(url).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};
const getSubAdmins = (data) =>
  postRequest("Admin/GetAllList", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
const addSubAdmin = (data) =>
  postRequest("Admin/Create", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
const updateSubAdmin = (data) =>
  putRequest("Admin", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
const updateAdminPassword = (data) =>
  postRequest("Admin/ChangePassword", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
const deleteSubAdmin = (id) =>
  deleteRequest(`Admin/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const getCustomers = (data) =>
  postRequest("User/GetAllList", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
const getCustomerDetails = (id) =>
  getRequest(`User/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const customerStatusUpdate = (id) =>
  putRequest(`User/UpdateStatus/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const getApprovedAgents = (data) =>
  postRequest("Agent/GetAllApprovedList", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const getAgentsApprovals = (data) =>
  postRequest("Agent/GetAllApprovalList", data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
const getAgentDetails = (id) =>
  getRequest(`Agent/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
const updateApprovalStatus = (data) =>
  putRequest(`Agent/UpdateApprovalStatus`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
const updateAgentStatus = (id) =>
  putRequest(`Agent/UpdateStatus/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const updateAdminStatus = (id) =>
  putRequest(`Admin/UpdateStatus/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const getAgentProperties = (id, body) =>
  postRequest(`Property/GetAllPropertyList/${id}`, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
const updatePropertyStatus = (id, body = {}) =>
  putRequest(`Property/UpdateStatus/${id}`, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const getCountriesSettings = (data) =>
  postRequest(`EligibleCountry/GetAllList`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const getCountriesSettingsDetails = (id) =>
  getRequest(`EligibleCountry/GetEligibleCountryDetail/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const createCountrySettings = (data) =>
  formDataPostRequest(`EligibleCountry/Create`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const updateCountrySettings = (data) =>
  formDataPutRequest(`EligibleCountry/Update`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const resendAdminEmail = (id) =>
  postRequest(`Admin/ResendInviteEmail/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const deleteCountrySetting = (id) =>
  deleteRequest(`EligibleCountry/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const getAdminNotifications = () =>
  getRequest(`Notification/Unread`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const updateNotificationStatus = (id) =>
  putRequest(`Notification/MarkNotificationAsRead/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const getAllFAQs = () =>
  getRequest(`FAQ`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const updateFAQs = (data) =>
  putRequest(`FAQ/bulk`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const updateAgentPaymentStatus = (id, body = {}) =>
  putRequest(`Agent/UpdatePaymentStatus/${id}`, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

export const adminService = {
  GetDashboardData,
  getSubAdmins,
  addSubAdmin,
  deleteSubAdmin,
  updateAdminPassword,
  getCustomers,
  customerStatusUpdate,
  getCustomerDetails,
  getApprovedAgents,
  getAgentsApprovals,
  getAgentDetails,
  updateApprovalStatus,
  updateAgentStatus,
  getAgentProperties,
  updatePropertyStatus,
  getCountriesSettings,
  createCountrySettings,
  getCountriesSettingsDetails,
  updateCountrySettings,
  resendAdminEmail,
  updateAdminStatus,
  updateSubAdmin,
  deleteCountrySetting,
  getAdminNotifications,
  updateNotificationStatus,
  getAllFAQs,
  updateFAQs,
  updateAgentPaymentStatus,
};
